import {CompanyModel} from './company.model';

export const BUSINESS_ROLES = ['all_roles', 'author', 'responsible', 'executor', 'observer', 'observer_contract'] as const
export type TBusinessRole = (typeof BUSINESS_ROLES)[number]

export interface MemberModel {
    email: string;
    firstname: string;
    guid: string;
    has_crypto: boolean;
    has_pin: boolean;
    has_avatar: boolean;
    is_active: boolean;
    is_blocked: boolean;
    join_date: string;
    language: string;
    lang?: string;
    lastname: string;
    middlename: string;
    phone: string;
    project_setting: ProjectSettings;
    projects_list: ProjectSettings[];

    // short model
    public_rsa_key?: string;

    //local use
    requestTime?: number;
    person?:boolean
    computed_name?:string
}
export interface IMemberWithRole {
    member:MemberModel,
    role:string
}

export interface ProjectSettings {
    is_project_admin: boolean;
    join_date: string;
    /** уникальный ключ пользователя в проекте */
    key: string;
    last_request: string;
    /** права доступа */
    observation_type: string;
    /** занимаемая должность */
    position: string;
    project: CompanyModel;
}

export interface UserRightsModel {
    collection_id: number;
    edit: boolean;
    file_id: number;
    folder_id: number;
    board_id: number;
    board_alias: string;
    id: number;
    name: string;
    read: boolean;
    sign: boolean;
    user_id: number;
    type?: string;
    link?: string;
    instance_id?: number;
    instance_type?: string;
    key?: string;
}

export interface IUserData {
    member_email: string,
    project_guid: string | null,
    can_verify: boolean,
    private_member?: boolean
}
